import { BaseIcon, BaseIconProps } from '../BaseIcon';

export type ChevronDownIconProps = Omit<BaseIconProps, 'children'>;

export const ChevronDownIcon = ({ ...props }: ChevronDownIconProps) => (
  <BaseIcon width="11" height="8" viewBox="0 0 11 8" fill="none" {...props}>
    <path d="M0.331044 0.756714C0.741554 0.387255 1.37384 0.420534 1.7433 0.831044L5.50001 5.00516L9.25671 0.831044C9.62617 0.420534 10.2585 0.387255 10.669 0.756714C11.0795 1.12617 11.1128 1.75846 10.7433 2.16897L6.2433 7.16897C6.05366 7.37969 5.78349 7.50001 5.50001 7.50001C5.21652 7.50001 4.94636 7.37969 4.75671 7.16897L0.256714 2.16897C-0.112745 1.75846 -0.0794662 1.12617 0.331044 0.756714Z" />
  </BaseIcon>
);

ChevronDownIcon.displayName = 'ChevronDownIcon';
